<section class="headerToperBgSec" [ngClass]="getRouteClass()" [class.displayNone]="userScrolledFromTop">
    <div class="mainContainer">
        <p class="topBannerText">

            <ng-container *ngIf="topLinkExternal; else internalLink">

                <span class="normalText">
                    {{ topText }}
                </span>

                <a [href]="topLinkExternal" target="_blank" rel="noopener noreferrer" class="companyWrapper">
                    <span class="companyName">
                        Vantheon Technologies
                    </span>

                    <span class="companySubText">
                        - part of KPI Group
                    </span>
                </a>

                <span class="divider"> | </span>

                <br class="mobileBreak" />

                <a href="https://vantheon.com" target="_blank" rel="noopener noreferrer" class="visitLink">
                    Visit vantheon →
                </a>

            </ng-container>

            <ng-template #internalLink>
                {{ topText }}
                <strong [routerLink]="[getRouteLink()]">
                    {{ topLink }}
                </strong>
            </ng-template>

        </p>
    </div>
</section>